// 接入多分支的配置数据需要在请求前加上/:mode/branch/:branchId/manage/
// 接入多环境的配置数据需要在请求前加上/:mode/env/:envId/manage/
// branchId和envId不指定的话会直接使用当前运行的env或者branch
export default function getManagePathPrefix({
  branchId,
  envId,
  isRuntimeRoute
} = {}) {
  const {
    xy_runtime_utils: utils = {}
  } = window;
  const pathPrefix = utils.getXyManagePathPrefix ? utils.getXyManagePathPrefix({
    branchId,
    envId,
    isRuntimeRoute
  }) : '/api/xy';
  return pathPrefix;
}
//# sourceMappingURL=getManagePathPrefix.js.map
